import axios from "axios";
import Auth from "@/utils/Auth"; // 验权
import { Message, MessageBox, Loading } from "element-ui";
let loadingInstance = "";

const HttpConnection = axios.create({
    baseURL: process.env.VUE_APP_PREFIX,
});

axios.defaults.timeout = 5 * 60 * 1000;
HttpConnection.defaults.headers.post["Content-Type"] = "application/json";

HttpConnection.interceptors.request.use(
    (config) => {
        let _token = Auth.getToken();
        if (_token) {
            config.headers["Authorization"] = _token;
        }
        loadingInstance = Loading.service({
            lock: true,
            text: "操作中，请稍后......",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

HttpConnection.interceptors.response.use(
    (response) => {
        const res = response.data;
        loadingInstance.close();
        const url = response.config.url;

        if (res.code === 200) {
            return Promise.resolve(res);
        } else {
            loadingInstance.close();
            if (url.indexOf("/openresource/clickCount") == -1) {
                MessageBox.alert(res.msg, "错误", {
                    confirmButtonText: "确定",
                    type: "error",
                });
            }
            return Promise.reject("error");
        }
    },
    (error) => {
        loadingInstance.close();
        Message({
            message: "连接超时（后台不能连接，请联系系统管理员）",
            type: "error",
            duration: 30 * 1000,
        });
        return Promise.reject(error);
    }
);

export default HttpConnection;
